import React, { useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import Head from '@/components/molecules/section/Head';
import { GridAction } from '@/components/molecules/section/Grid';
import styles from './Container.module.scss';

const View: React.FC<{
  title: string;
  testId?: string;
  actions: GridAction[];
  children?: React.ReactElement;
  handler?: {
    open: boolean;
    setOpen: (b: boolean) => void;
  };
}> = ({ title, actions, children, handler, testId }) => {
  const [open, setOpen] = useState(true);

  const _open = handler ? handler.open : open;
  const _setOpen = handler ? handler.setOpen : setOpen;

  return (
    <div
      className={styles.container}
      data-cy={`${testId} section-wrapper`}
    >
      <div className={_open ? styles.head : ''}>
        <Head
          title={title}
          open={_open}
          setOpen={_setOpen}
          actions={actions}
        />
      </div>
      <Accordion
        sx={{
          margin: '0 !important', // Stupid MUI
          boxShadow: 'none',
          background: 'none',
          border: 'none',
          '&:before': { display: 'none' },
        }}
        expanded={_open}
      >
        <AccordionSummary sx={{ display: 'none' }} />
        <AccordionDetails sx={{ boxShadow: 'none', padding: 0, border: 0 }}>{children}</AccordionDetails>
      </Accordion>
    </div>
  );
};

export default View;
